import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, ShoppingBag, X, Search } from "lucide-react";
import { useEnquiryCart } from "@/contexts/EnquiryCartContext";

const links = [
    { to: "/catalog", label: "Catalog" },
    { to: "/catalog?cat=Necklace", label: "Necklaces" },
    { to: "/catalog?cat=Choker", label: "Chokers" },
    { to: "/catalog?cat=Bangles", label: "Bangles" },
    { to: "/catalog?cat=Earrings", label: "Earrings" },
    { to: "/about", label: "About" },
];export default function Navbar() {
    const { count, setOpen } = useEnquiryCart();
    const [mobile, setMobile] = useState(false);
    const navigate = useNavigate();

    return (
        <header className="sticky top-0 z-40 bg-paper/95 backdrop-blur border-b border-soft">
            <div className="bg-ink text-paper text-[11px] tracking-[0.22em] uppercase text-center py-2">
                Wholesale only · No retail sales · Trade enquiries on WhatsApp
            </div>
            <div className="max-w-[1480px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
                <button
                    data-testid="nav-mobile-toggle"
                    className="md:hidden text-ink"
                    onClick={() => setMobile((s) => !s)}
                    aria-label="Menu"
                >
                    {mobile ? <X size={20} /> : <Menu size={20} />}
                </button>

                <Link to="/" className="flex items-baseline gap-2 mx-auto md:mx-0" data-testid="nav-logo">
                    <span className="font-serif text-3xl md:text-4xl text-ink tracking-tight">Gold</span>
                    <span className="overline text-[9px] mt-1">by</span>
                    <span className="font-serif text-3xl md:text-4xl italic text-bronze-deep tracking-tight">SRN</span>
                </Link>

                <nav className="hidden md:flex items-center gap-8 absolute left-1/2 -translate-x-1/2 top-[58px]">
                    {links.map((l) => (
                        <NavLink
                            key={l.label}
                            to={l.to}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
                            className={({ isActive }) =>
                                `underline-grow text-[11px] tracking-[0.24em] uppercase ${isActive ? 'text-bronze-deep' : 'text-ink/85 hover:text-ink'}`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <Link to="/contact" className="hidden md:block text-[11px] uppercase tracking-[0.22em] text-ink/80 underline-grow" data-testid="nav-link-contact">
                        Contact
                    </Link>
                    <button
                        data-testid="nav-open-cart"
                        onClick={() => setOpen(true)}
                        className="relative flex items-center gap-2 text-ink hover:text-bronze-deep transition-colors"
                        aria-label="Open enquiry"
                    >
                        <ShoppingBag size={18} />
                        <span className="hidden sm:inline text-[11px] uppercase tracking-[0.22em]">Enquiry</span>
                        {count > 0 && (
                            <span data-testid="nav-cart-count" className="absolute -top-2 -right-3 bg-bronze-deep text-paper text-[10px] font-semibold rounded-full w-5 h-5 flex items-center justify-center">{count}</span>
                        )}
                    </button>
                </div>
            </div>

            {mobile && (
                <div className="md:hidden bg-paper border-t border-soft px-6 py-6 space-y-4">
                    {[...links, { to: "/contact", label: "Contact" }].map((l) => (
                        <button
                            key={l.label}
                            data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s/g, '-')}`}
                            onClick={() => { navigate(l.to); setMobile(false); }}
                            className="block w-full text-left text-[12px] uppercase tracking-[0.22em] text-ink/85"
                        >
                            {l.label}
                        </button>
                    ))}
                </div>
            )}
        </header>
    );
}
